export default {
  addToast(state, { message }) {
    state.toast.message = message;
  },

  clearToast(state) {
    state.toast.message = '';
  }
}
